
<template>
     <a-select show-search :value="value" placeholder="输入syscode"  allow-clear style="width: 200px"
         :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null"
         @search="handleSearch" @change="handleChange">
         <a-select-option v-for="d in data" :key="d.value">
             {{ d.text }}
         </a-select-option>
     </a-select>
</template>
<script>

export default {
    data() {
        return {
            data: [],
            originData:[],
            value:undefined
        }
    },

    props:{
        svalue:String
    },

    methods: {
        setInputVal(val){
            this.value = val
        },
        handleChange(value) {
            this.value = value;
            this.$emit('onSysCodeChange',value,this.originData);
        },
        handleSearch(value) {
            let that = this;
            let c_params = {
                pageSize: 10,
                page: 1,
                flag: 1,
                urlparams: false,
                syscode: value,
            }

            that.$store.dispatch({
                type: "usercenter/selectSystemList",
                params: c_params,
                showMsg: false
            }).then((res) => {
                if (res.data.success == 1) {
                    that.data = [];
                    let result = res.data.data.list;
                    if(!result){
                        return;
                    }
                    this.originData = result;
                    result.forEach(r => {
                        that.data.push({
                            value: r.syscode,
                            text: r.syscode,
                        });
                    });
                }
            })
        },
    },
   
};
</script>

<style scoped>

</style>
